import React, { useState, useEffect, useRef } from 'react';
import './App.css';

const icons = {
  fire: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>,
  search: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  headphones: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>,
  music: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>,
  download: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>,
  palette: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="13.5" cy="6.5" r=".5"/><circle cx="17.5" cy="10.5" r=".5"/><circle cx="8.5" cy="7.5" r=".5"/><circle cx="6.5" cy="12.5" r=".5"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/></svg>,
  gmail: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>,
  sun: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>,
  moon: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>,
  globe: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  chevronDown: <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>,
  send: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M3.478 2.404a.75.75 0 00-.926.941l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.404z" /></svg>,
  menu: <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>,
  close: <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>,
  playStore: <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 3.71v16.58a.7.7 0 0 0 1.05.6l14.6-8.3a.7.7 0 0 0 0-1.2l-14.6-8.3a.7.7 0 0 0-1.05.6z"></path><path d="M15.6 10.3l-11.6 10"></path><path d="M15.6 13.7l-11.6-10"></path></svg>,
  wavyArrow: <svg xmlns="http://www.w3.org/2000/svg" width="180" height="60" viewBox="0 0 180 60" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" className="wavy-arrow-svg"><path d="M 5,30 C 50,80 130,30 170,30" className="arrow-path" /><path d="M 155,15 L 170,30 L 155,45" className="arrow-head" /></svg>,
  apple: <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.56-1.702z"/></svg>,
  share: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>,
  userPlus: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>,
  instagram: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>,
  linkedin: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>,
  history: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>,
  more: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="2"></circle><circle cx="19" cy="12" r="2"></circle><circle cx="5" cy="12" r="2"></circle></svg>,
};

const content = {
  en: {
    brand: "OYN Music",
    navFeatures: "Features",
    navContact: "Contact",
    themeLight: "Light Mode",
    themeDark: "Dark Mode",
    heroTitle: "Discover Your Vibe.",
    heroDesc: "A modern, user-friendly music player designed for your ultimate listening experience. Dive into a world of endless melodies.",
    ctaIos: "App Store",
    ctaAndroid: "Google Play",
    featuresTitle: "Next-Generation Features",
    learnMore: "Learn More",
    features: [
      { title: "Trending Hits", desc: "Discover the most popular tracks and featured albums curated just for you.", modalDesc: "Stay ahead of the curve. Our algorithms analyze global listening patterns to bring you the hottest tracks right now. Browse by country or global charts seamlessly.", icon: icons.fire, image: "/oyn_music_ekran/ekran1.png", bgAnimation: "trending" },
      { title: "Advanced Search", desc: "Find any song, album, or artist effortlessly with our lightning-fast search.", modalDesc: "Not sure of the song name? Type lyrics, mood, or even the year. Our robust search engine instantly scans millions of tracks to find exactly what you need.", icon: icons.search, image: "/oyn_music_ekran/ekran7.png", bgAnimation: "search" },
      { title: "Seamless Playback", desc: "Uninterrupted background play with shuffle, repeat, and gapless transitions.", modalDesc: "Enjoy music the way it was meant to be heard. With gapless transitions and intelligent background playback, your music never stops, even when you switch apps.", icon: icons.headphones, image: "/oyn_music_ekran/ekran3.png", bgAnimation: "playback" },
      { title: "Custom Playlists", desc: "Create, manage, and organize your favorite tracks into personalized folders.", modalDesc: "Be your own DJ. Organize your tracks into nested folders, add custom cover arts, and easily drag-and-drop songs to curate the perfect vibe for any occasion.", icon: icons.music, image: "/oyn_music_ekran/ekran5.png", bgAnimation: "playlist" },
      { title: "Free Download & Offline", desc: "Download your favorite music to your device for free and enjoy uninterrupted listening without an internet connection.", modalDesc: "Take your music everywhere. Download unlimited tracks over Wi-Fi and listen on the go without worrying about data usage or internet connection drops.", icon: icons.download, image: "/oyn_music_ekran/ekran8.png", bgAnimation: "download" },
      { title: "Follow Artists", desc: "Follow your favorite artists to instantly discover their new releases.", modalDesc: "Never miss a beat. Get instant push notifications when your favorite artists drop a new single, album, or announce an upcoming tour.", icon: icons.userPlus, image: "/oyn_music_ekran/ekran2.png", bgAnimation: "follow" },
      { title: "Personalization", desc: "Customize your app with dynamic dark/light modes and custom accent colors.", modalDesc: "Match the app to your mood. Choose from a selection of carefully crafted dynamic themes, switch between deep dark or bright light modes, and customize accent colors.", icon: icons.palette, image: null, bgAnimation: "personalization" },
      { title: "Share with Friends", desc: "Easily share your favorite tracks and playlists with your friends.", modalDesc: "Music is better together. Share your top tracks and collaborative playlists across social media or via direct links with just a single tap.", icon: icons.share, image: null, bgAnimation: "share" },
      { title: "Music History", desc: "Quickly access your recently played tracks and rediscover past favorites.", modalDesc: "Never lose a great song. Your listening history is automatically saved, allowing you to pick up seamlessly where you left off or find that catchy tune from last week.", icon: icons.history, image: "/oyn_music_ekran/ekran4.png", bgAnimation: "history" },
      { title: "And More", desc: "We are constantly pushing the boundaries of your music experience with continuous updates and new features.", modalDesc: "We are working hard to bring your music experience beyond limits. Features like lyric integration, advanced equalizer settings, and much more...", icon: icons.more, image: null, bgAnimation: "more" },
    ],
    contactTitle: "Get in Touch",
    contactName: "Your Name",
    contactEmail: "Your Email",
    contactMessage: "Your Message",
    contactSubmit: "Send Message",
    messageSent: "Message sent successfully!",
    privacyPolicy: "Privacy Policy",
    footer: "© 2026 OYN Music. All rights reserved.",
    comingSoon: "Coming soon for iOS!"
  },
  tr: {
    brand: "OYN Music",
    navFeatures: "Özellikler",
    navContact: "İletişim",
    themeLight: "Açık Tema",
    themeDark: "Koyu Tema",
    heroTitle: "Tarzınızı Keşfedin.",
    heroDesc: "En iyi dinleme deneyiminiz için tasarlanmış modern, kullanıcı dostu bir müzik çalar. Sonsuz melodiler dünyasına dalın.",
    ctaIos: "App Store",
    ctaAndroid: "Google Play",
    featuresTitle: "Yeni Nesil Özellikler",
    learnMore: "Daha Fazla Bilgi",
    features: [
      { title: "Trendler", desc: "Sizin için özenle seçilmiş en popüler şarkıları ve öne çıkan albümleri keşfedin.", modalDesc: "Trendlerin gerisinde kalmayın. Algoritmalarımız küresel dinleme alışkanlıklarını analiz ederek size en popüler şarkıları sunar. Ülkelere veya global listelere göre gezinebilirsiniz.", icon: icons.fire, image: "/oyn_music_ekran/ekran1.png", bgAnimation: "trending" },
      { title: "Gelişmiş Arama", desc: "Işık hızında arama motorumuzla istediğiniz şarkıyı, albümü veya sanatçıyı anında bulun.", modalDesc: "Şarkının adını tam hatırlamıyor musunuz? Sözleri, ruh halini veya yılı yazın. Güçlü arama motorumuz tam olarak aradığınızı bulmak için milyonlarca şarkıyı anında tarar.", icon: icons.search, image: "/oyn_music_ekran/ekran7.png", bgAnimation: "search" },
      { title: "Kesintisiz Müzik", desc: "Arka planda çalma, karışık çalma ve tekrar modlarıyla kesintisiz müzik keyfi.", modalDesc: "Müziğin keyfini çıkarın. Boşluksuz geçişler ve akıllı arka plan oynatma özelliği sayesinde, uygulamalar arasında geçiş yapsanız bile müziğiniz asla durmaz.", icon: icons.headphones, image: "/oyn_music_ekran/ekran3.png", bgAnimation: "playback" },
      { title: "Özel Çalma Listeleri", desc: "Favori şarkılarınızı kişiselleştirilmiş klasörlerde toplayın ve yönetin.", modalDesc: "Kendi DJ'iniz olun. Şarkılarınızı iç içe klasörlerde düzenleyin, özel kapak fotoğrafları ekleyin ve sürükle-bırak yöntemiyle her duruma uygun mükemmel listeler oluşturun.", icon: icons.music, image: "/oyn_music_ekran/ekran5.png", bgAnimation: "playlist" },
      { title: "Ücretsiz İndir ve Çevrimdışı Dinle", desc: "İstediğiniz müzikleri cihazınıza ücretsiz olarak indirin ve internet bağlantısına ihtiyaç duymadan kesintisiz dinleyin.", modalDesc: "Müziğinizi her yere götürün. Wi-Fi üzerinden sınırsız şarkı indirin ve veri kullanımını veya internet kesintilerini dert etmeden hareket halindeyken dinleyin.", icon: icons.download, image: "/oyn_music_ekran/ekran8.png", bgAnimation: "download" },
      { title: "Sanatçıları Takip Edin", desc: "Sanatçıları takip ederek yeni müziklerle ve güncel albümlerle anında tanışın.", modalDesc: "Hiçbir yeniliği kaçırmayın. Favori sanatçılarınız yeni bir single veya albüm çıkardığında anında anlık bildirimler alın.", icon: icons.userPlus, image: "/oyn_music_ekran/ekran2.png", bgAnimation: "follow" },
      { title: "Kişiselleştirme", desc: "Dinamik karanlık/aydınlık modlar ve özel tema renkleriyle uygulamanızı özelleştirin.", modalDesc: "Uygulamayı ruh halinize uydurun. Özenle hazırlanmış dinamik temalar arasından seçim yapın, derin karanlık veya aydınlık modlar arasında geçiş yapın ve vurgu renklerini özelleştirin.", icon: icons.palette, image: null, bgAnimation: "personalization" },
      { title: "Arkadaşlarınızla Paylaşın", desc: "Beğendiğiniz müzikleri ve çalma listelerinizi arkadaşlarınızla kolayca paylaşın.", modalDesc: "Müzik paylaştıkça güzeldir. Sadece tek bir dokunuşla favori şarkılarınızı ve ortak çalma listelerinizi sosyal medya üzerinden veya doğrudan bağlantılarla paylaşın.", icon: icons.share, image: null, bgAnimation: "share" },
      { title: "Müzik Geçmişi", desc: "Son çaldığınız parçalara kolayca erişin ve geçmiş favorilerinizi yeniden keşfedin.", modalDesc: "Harika bir şarkıyı asla kaybetmeyin. Dinleme geçmişiniz otomatik olarak kaydedilir, böylece kaldığınız yerden sorunsuzca devam edebilir veya geçen haftaki o akılda kalıcı melodiyi kolayca bulabilirsiniz.", icon: icons.history, image: "/oyn_music_ekran/ekran4.png", bgAnimation: "history" },
      { title: "Daha Fazlası", desc: "Sürekli eklenen yeni özellikler ve güncellemeler ile müzik deneyiminizi her geçen gün daha da ileriye taşıyoruz.", modalDesc: "Müzik deneyimini sınırların ötesine taşımak için çalışıyoruz. Şarkı sözü entegrasyonu, gelişmiş ses ekolayzer ayarları ve daha fazlası...", icon: icons.more, image: null, bgAnimation: "more" },
    ],
    contactTitle: "Bize Ulaşın",
    contactName: "Adınız",
    contactEmail: "E-posta Adresiniz",
    contactMessage: "Mesajınız",
    contactSubmit: "Mesajı Gönder",
    messageSent: "Mesajınız başarıyla gönderildi!",
    privacyPolicy: "Gizlilik Politikası",
    footer: "© 2026 OYN Music. Tüm hakları saklıdır.",
    comingSoon: "iOS için çok yakında!"
  }
};

const BackgroundAnimation = ({ type }) => {
  switch (type) {
    case 'trending':
      return (
        <svg className="bg-anim-trending" viewBox="0 0 1000 400" preserveAspectRatio="none">
          <path id="trendingLine" className="trending-path" pathLength="100" d="M 0,400 L 200,250 L 400,300 L 600,150 L 800,200 L 1000,0" fill="none" stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
          <polyline className="trending-arrow" points="-25,-25 0,0 -25,25" fill="none" stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round">
            <animateMotion dur="4s" repeatCount="indefinite" keyPoints="0;1;1" keyTimes="0;0.5;1" calcMode="linear" rotate="auto">
              <mpath href="#trendingLine" />
            </animateMotion>
          </polyline>
        </svg>
      );
    case 'search':
      return (
        <div className="bg-anim-search">
          <div className="ring ring1"></div>
          <div className="ring ring2"></div>
          <div className="ring ring3"></div>
        </div>
      );
    case 'playback':
      return (
        <div className="bg-anim-playback">
          {[...Array(12)].map((_, i) => <div key={i} className={`sound-bar bar-${i + 1}`}></div>)}
        </div>
      );
    case 'playlist':
      return (
        <div className="bg-anim-playlist">
          <div className="note note1">{icons.music}</div>
          <div className="note note2">{icons.music}</div>
          <div className="note note3">{icons.music}</div>
        </div>
      );
    case 'download':
      return (
        <div className="bg-anim-download">
          {[...Array(3)].map((_, i) => (
            <div key={i} className={`download-arrow arrow-${i+1}`}>{icons.chevronDown}</div>
          ))}
        </div>
      );
    case 'follow':
      return (
        <div className="bg-anim-follow">
           {[...Array(3)].map((_, i) => (
            <div key={i} className={`follow-icon icon-${i+1}`}>{icons.userPlus}</div>
          ))}
        </div>
      );
    case 'history':
      return (
        <div className="bg-anim-history">
          <div className="history-icon-bg">{icons.history}</div>
        </div>
      );
    case 'personalization':
      return (
        <div className="bg-anim-personalization">
          <div className="blob blob1"></div>
          <div className="blob blob2"></div>
        </div>
      );
    case 'share':
      return (
        <div className="bg-anim-share">
          <div className="share-node node1">{icons.share}</div>
          <div className="share-node node2">{icons.share}</div>
          <div className="share-node node3">{icons.share}</div>
        </div>
      );
    case 'more':
      return (
        <div className="bg-anim-more">
          <div className="more-dot"></div>
          <div className="more-dot"></div>
          <div className="more-dot"></div>
        </div>
      );
    default:
      return null;
  }
};

function App() {
  const [lang, setLang] = useState('en');
  const [isContactVisible, setIsContactVisible] = useState(false);
  const [isFeaturesVisible, setIsFeaturesVisible] = useState(false);
  const [isDownloadVisible, setIsDownloadVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [contactData, setContactData] = useState({ name: '', email: '', message: '' });
  const [toast, setToast] = useState({ show: false, icon: null, message: '' });
  const [selectedFeature, setSelectedFeature] = useState(null);
  
  const contactRef = useRef(null);
  const featuresRef = useRef(null);
  const downloadRef = useRef(null);
  const toastTimerRef = useRef(null);
  const t = content[lang];

  const toggleLanguage = () => {
    setLang(prev => (prev === 'en' ? 'tr' : 'en'));
  };

  const scrollToSection = (ref) => {
    setIsMenuOpen(false);
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const showToastMessage = (icon, message) => {
    setToast({ show: true, icon, message });
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => {
      setToast(prev => ({ ...prev, show: false }));
    }, 3000);
  };

  const handleIosDownload = () => {
    showToastMessage(icons.apple, t.comingSoon);
  };

  const handleAndroidDownload = () => {
    window.open("https://play.google.com/store/apps/details?id=com.ahmed.oyn_music", "_blank");
  };

  const playPopSound = () => {
    try {
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioCtx.createOscillator();
      const gainNode = audioCtx.createGain();

      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(400, audioCtx.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(800, audioCtx.currentTime + 0.15);

      gainNode.gain.setValueAtTime(0.3, audioCtx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.15);

      oscillator.connect(gainNode);
      gainNode.connect(audioCtx.destination);
      oscillator.start();
      oscillator.stop(audioCtx.currentTime + 0.15);
    } catch (error) {
      console.warn("Ses efekti oynatılamadı:", error);
    }
  };

  const toggleContact = () => {
    playPopSound();
    setIsContactOpen(prev => !prev);
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = contactData;
    const subject = encodeURIComponent(`OYN Music İletişim Formu - ${name}`);
    const body = encodeURIComponent(`İsim: ${name}\nE-posta: ${email}\n\nMesaj:\n${message}`);
    window.location.href = `mailto:ahmedoyan101@gmail.com?subject=${subject}&body=${body}`;
    setContactData({ name: '', email: '', message: '' });
    showToastMessage(icons.send, t.messageSent);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === featuresRef.current) setIsFeaturesVisible(true);
            if (entry.target === contactRef.current) setIsContactVisible(true);
            if (entry.target === downloadRef.current) setIsDownloadVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.01 } // Mobil ekranlarda çok uzun elementlerin görünebilmesi için düşürüldü
    );

    if (featuresRef.current) observer.observe(featuresRef.current);
    if (downloadRef.current) observer.observe(downloadRef.current);
    if (contactRef.current) observer.observe(contactRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="App dark">
      <nav className="navbar">
        <div className="logo">
          <img src="/OYN_ana_logo_seffaf.png" alt="OYN Music Logo" className="nav-logo-icon" />
          {t.brand}
        </div>
        
        <div className={`nav-content ${isMenuOpen ? 'open' : ''}`}>
          <div className="nav-links">
            <span onClick={() => scrollToSection(featuresRef)}>{t.navFeatures}</span>
            <span onClick={() => scrollToSection(contactRef)}>{t.navContact}</span>
          </div>
          <div className="nav-actions">
            <button className="nav-btn" onClick={toggleLanguage}>
              {icons.globe}
              <span>{lang === 'en' ? 'Türkçe' : 'English'}</span>
            </button>
          </div>
        </div>

        <button className="hamburger-btn" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? icons.close : icons.menu}
        </button>
      </nav>

      <section className="hero">
        <div className="hero-content">
          <h1 className="animate-fade-up">{t.heroTitle}</h1>
          <p className="animate-fade-up delay-1">{t.heroDesc}</p>
          <div className="scroll-indicator-wrapper animate-fade-up delay-2">
            <div className="scroll-indicator" onClick={() => scrollToSection(featuresRef)}>
              {icons.chevronDown}
            </div>
          </div>
        </div>
        <div className="hero-mockup animate-fade-up delay-2">
          <div className="logo-mockup-container">
            <div className="logo-blur-bg" style={{ backgroundColor: '#f59e0b' }}></div>
            <img src="/OYN_ana_logo_seffaf.png" alt="OYN Music Logo" className="embedded-logo" />
          </div>
        </div>
      </section>

      <section className="features-section" ref={featuresRef}>
        <div className="features-container">
          {/* Ekranlı Özellikler (Resmi olanları otomatik filtreler) */}
          {t.features.filter(f => f.image).map((feature, index) => (
            <div 
              className={`feature-row scroll-animate ${isFeaturesVisible ? 'animate-fade-up' : ''} theme-${feature.bgAnimation}`} 
              key={index}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="feature-bg-wrapper">
                <BackgroundAnimation type={feature.bgAnimation} />
              </div>
              <div className="feature-info">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
                <button className="learn-more-btn" onClick={() => setSelectedFeature(feature)}>
                  {t.learnMore}
                </button>
              </div>
              <div className="feature-mockup">
                  <div className="iphone-mockup single">
                    <div className="dynamic-island"></div>
                    <img src={feature.image} alt={feature.title} />
                  </div>
              </div>
            </div>
          ))}

          {/* Ekransız Alt Özellikler (Resmi 'null' olanları otomatik filtreler) */}
          <div className="bottom-features-grid">
            {t.features.filter(f => !f.image).map((feature, index) => (
              <div 
                className={`feature-card scroll-animate ${isFeaturesVisible ? 'animate-fade-up' : ''} theme-${feature.bgAnimation}`} 
                key={`bottom-${index}`}
                style={{ animationDelay: `${0.8 + (index * 0.15)}s` }}
              >
                <div className="feature-bg-wrapper">
                  <BackgroundAnimation type={feature.bgAnimation} />
                </div>
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
                <button className="learn-more-btn" onClick={() => setSelectedFeature(feature)}>
                  {t.learnMore}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="download-section" ref={downloadRef}>
        <img src="/OYN_ana_logo_seffaf.png" alt="OYN Music Icon" className={`app-icon scroll-animate ${isDownloadVisible ? 'animate-fade-up' : ''}`} />
        <div className={`wavy-arrow-container scroll-animate ${isDownloadVisible ? 'animate-fade-up delay-1' : ''}`}>
          {icons.wavyArrow}
        </div>
        <div className={`download-buttons scroll-animate ${isDownloadVisible ? 'animate-fade-up delay-2' : ''}`}>
          <button className="cta-btn" onClick={handleIosDownload}>
            {icons.apple}
            <span>{t.ctaIos}</span>
          </button>
          <button className="cta-btn" onClick={handleAndroidDownload}>
            {icons.playStore}
            <span>{t.ctaAndroid}</span>
          </button>
        </div>
      </section>

      <section className="contact-section" ref={contactRef}>
        <h2 
          className={`contact-title scroll-animate ${isContactVisible ? 'animate-fade-up' : ''}`}
          onClick={toggleContact}
        >
          <span className="contact-icon">{icons.gmail}</span>
          {t.contactTitle}
          <span className={`chevron ${isContactOpen ? 'open' : ''}`}>{icons.chevronDown}</span>
        </h2>
        <div className={`contact-wrapper scroll-animate ${isContactVisible ? 'animate-fade-up delay-1' : ''} ${isContactOpen ? 'open' : ''}`}>
          <div className="contact-wrapper-inner">
            <div className="contact-container">
              <form className="contact-form" onSubmit={handleContactSubmit}>
                <div className="form-group">
                  <input 
                    type="text" 
                    placeholder={t.contactName} 
                    required 
                    value={contactData.name}
                    onChange={e => setContactData({...contactData, name: e.target.value})}
                  />
                </div>
                <div className="form-group">
                  <input 
                    type="email" 
                    placeholder={t.contactEmail} 
                    required 
                    value={contactData.email}
                    onChange={e => setContactData({...contactData, email: e.target.value})}
                  />
                </div>
                <div className="form-group">
                  <textarea 
                    placeholder={t.contactMessage} 
                    rows="5" 
                    required
                    value={contactData.message}
                    onChange={e => setContactData({...contactData, message: e.target.value})}
                  ></textarea>
                </div>
                <button type="submit" className="submit-btn">
                  {icons.send}
                  <span>{t.contactSubmit}</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <p>{t.footer}</p>
        <div className="footer-links">
          <a href="/privacy.html" target="_blank" rel="noopener noreferrer">{t.privacyPolicy}</a>
          <div className="social-links">
            <a href="https://www.instagram.com/ahmetoyan.l4/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">{icons.instagram}</a>
            <a href="https://www.linkedin.com/in/ahmet-oyan-21bb11330/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">{icons.linkedin}</a>
          </div>
        </div>
      </footer>

      <div className={`toast ${toast.show ? 'show' : ''}`}>
        {toast.icon}
        <span>{toast.message}</span>
      </div>

      {/* Feature Modal */}
      <div className={`modal-overlay ${selectedFeature ? 'open' : ''}`} onClick={() => setSelectedFeature(null)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="modal-close" onClick={() => setSelectedFeature(null)}>{icons.close}</button>
          {selectedFeature && (
            <>
              <div className="modal-icon">{selectedFeature.icon}</div>
              <h3>{selectedFeature.title}</h3>
              <p>{selectedFeature.modalDesc}</p>
            </>
          )}
        </div>
      </div>

    </div>
  );
}

export default App;